<template>
  <div
    v-if="
      item && item.id
    "
    class="item">
    <div class="heading">
      <div class="icon">
        <img
          :src="item.icon"
          @error="
            event => imgError(event)
          "
        />
      </div>
      <div class="content">
        <div class="name">
          <p class="code">
            {{ item.code }}
          </p>
          <p
            class="
              subtitle ellipsis
            ">
            {{ name.tha }}
          </p>
        </div>
        <p class="pin">
          <span
            v-if="
              item.location
            ">
            <i class="el-icon-location" /> {{ item.location }}
          </span>
          <span v-else class="unknown">
            N/A
          </span>
        </p>
      </div>
    </div>
    <div class="action">
      <el-button
        type="sc-asset-light"
        icon="
          el-icon-s-home
        "
        @click="
          () => home(item.id)
        ">
        รายการบ้าน
      </el-button>
      <el-button
        type="sc-asset"
        icon="
          el-icon-edit-outline
        "
        @click="
          () => edit(item.id)
        ">
        เปิด
      </el-button>
    </div>
  </div>
</template>

<script lang="js">

export default {
  props: {
    project: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data: () => ({
    item: {
      code: null,
      id: null,
      icon: null,
      name: {
        tha: null,
        eng: null
      },
      location: null,
      created_at: null
    }
  }),
  computed: {
    name () {
      return this.item.name
    },
  },
  watch: {
    project: {
      handler (value) {
        this.item = value
      },
      deep: true
    }
  },
  mounted() {
    this.item = this.project
  },
  methods: {
    imgError(e) {
      e.target.src = 'https://www.scasset.com/images/sca-orange.svg'
    },
    home(projectId) {
      
      // Route Name
      const name = 'nonsc-project-home'

      // Import Project
      this.$router.push({
        name, params: { projectId }
      })
    },
    importUser(code) {

      // Route Name
      const name = 'nonsc-project-import'

      // Import Project
      this.$router.push({
        name, params: { code }
      })
    },
    edit(projectId) {
      
      // Route Name
      const name = 'nonsc-project-update'

      // Update Project
      this.$router.push({
        name, params: { projectId }
      })
    }
  }
}

</script>

<style lang="css" scoped>

.item {
  align-items : center;
  gap         : var(--size-md);
  padding     : var(--size-md);
}

p {
  line-height: var(--size-lg);
}

.item .heading {
  display     : flex;
  flex        : 1;
  gap         : var(--size-md);
  align-items : center;
  overflow    : hidden;
}
.item .icon {
  flex: none;
}
.item .content {
  flex            : 1;
  display         : flex;
  justify-content : space-between;
  overflow        : hidden;
}
.item .content .name {
  flex      : 5;
  overflow  : hidden;
}
.item .content .pin {
  flex        : 2;
  display     : flex;
  align-items : center;
}
.item .action {
  flex            : none;
  display         : flex;
  align-items     : center;
  justify-content : space-between;
  gap             : var(--size-sm);
}

.code {
  font-weight : bold;
  font-size   : calc(.125rem + var(--size-md));
}

.icon img {
  width         : 4rem;
  aspect-ratio  : 1/1;
  object-fit    : contain;
  border-radius : var(--size-xs);
}

@media screen and (max-width: 1280px) {
  
  .item {
    flex-direction  : column;
    align-items     : flex-end;
    gap             : var(--size-xs);
  }

  .item .heading {
    align-items : start;
  }

  .item .heading,
  .item .action {
    width           : 100%;
    justify-content : flex-end;
  }
 
  .item .content .pin {
    align-items     : flex-start;
    justify-content : flex-end;
  }
}

@media screen and (max-width: 480px) {

  .item .content {
    gap             : var(--size-xs);
    flex-direction  : column;
  }
}


</style>